import { BrandType } from 'models/brand.model';
import { CreateDealType, DealMetaDataType } from 'models/deals.model';
import { MealType } from 'models/meal.model';
import { UserType } from 'models/user.model';
import { ChangeEvent, createContext, useContext } from 'react';

export type DealContextType = {
  createDealForm: CreateDealType;
  setCreateDealForm: (k: CreateDealType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  dealValueTypes: DealMetaDataType[];
  dealTypes: DealMetaDataType[];
  dealRequirementTypes: DealMetaDataType[];
  dealEligibilityTypes: DealMetaDataType[];
  brands: BrandType[];
  users: UserType[];
  setUserSearchValue: (val: string) => void;
  mealBrands: string[];
  setMealBrands: (val: string[]) => void;
  meals: MealType[];
  images: string[];
  setImages: (val: string[]) => void;
};

export const CreateDealContext = createContext({} as DealContextType);

const useCreateDealContext = () => {
  const context = useContext(CreateDealContext);
  return context;
};

export default useCreateDealContext;
